export default __webpack_public_path__ + "static/media/ff2.b2741149.jpg";